import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  claimInformation: {
    height: 'fit-content',
    padding: '16px 24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
  },
  cardInputText:
  {
    '& > .Mui-error > fieldset': {
      borderColor: `${theme.evPalette.rose[900]} !important`,
    },
  },
  cardInputHelperText: {
    color: `${theme.evPalette.rose[900]} !important`,
  },
  asterisk: {
    color: `${theme.evPalette.rose[900]} !important`,
  },
  label: {
    fontSize: '1rem',
    color: theme.evPalette.charcoal[800],
    marginBottom: theme.spacing(1),
    '&.Mui-error,&.error': {
      color: `${theme.evPalette.rose[900]} !important`,
    },
  },
  fieldContainer: {
    marginBottom: theme.spacing(3),
    '& .myev-MuiFormHelperText-contained': {
      marginLeft: 0,
    },
    '& .myev-MuiCheckbox-root': {
      marginLeft: '-9px',
    },
  },
}));
